// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"Error404_errorContainer__Vx4mm","title":"Error404_title__1bzuB"};